import { IProjectCashCurve } from '../../interfaces/iproject-cash-curve';
import { CashCurveType } from '../cash-curve-type';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Project } from '../project';

export class ProjectCashCurveBase {
  ProjectCashCurveId: number;
  ProjectId: number | null;
  CostCodeCostTypeId: number | null;
  CashCurveTypeId: number | null;
  PeriodMonth: Date | null;
  Amount: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CashCurveType?: CashCurveType;
  CostCodeCostType?: CostCodeCostType;
  Project?: Project;

  constructor(item?: IProjectCashCurve) {
    if (item) {

      this.ProjectCashCurveId = item.ProjectCashCurveId;
      this.ProjectId = item.ProjectId;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.CashCurveTypeId = item.CashCurveTypeId;
      this.PeriodMonth = item.PeriodMonth ? new Date(item.PeriodMonth) : null;
      this.Amount = item.Amount;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CashCurveType = new CashCurveType(item.CashCurveType);
      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.Project = new Project(item.Project);
    }
  }
}